import './car-archive.scss'

( function() {
	'use strict';

	const init = () => {
		// Skip initialization if we're on the archive page (archive.js handles it)
		// Check if we're on the archive page by looking for the form or archive-specific classes
		const form = document.querySelector( '#entity-search-form' );
		const isLegacyPluginArchive =
			form !== null &&
			! form.dataset.aanbodNewRest;

		// Legacy plugin archive uses voertuig/archive.js (LiveForm); API aanbod uses this module.
		if ( isLegacyPluginArchive ) {
			return;
		}

		const openButton = document.querySelector( '.js-open-filters' );
		const overlay = document.querySelector( '.m-archiveFilterOverlay' );

		// De sidebar-inhoud wordt bij elke filterwijziging live herbouwd door
		// js/aanbod-new/archive.js, dus de sluitknoppen zijn dan nieuwe nodes.
		// Daarom alles op het moment zelf opzoeken in plaats van vasthouden:
		// een bij init bewaarde referentie wijst na de eerste filterklik naar een
		// losgekoppelde node en dan doet het paneel niets meer.
		const getFilter = () => document.querySelector( '.m-archiveFilter' );
		const getCloseButtons = () => Array.from( document.querySelectorAll( '.js-close-filters' ) );

		if ( ! openButton || ! getFilter() ) {
			return;
		}

		let activeElementBeforeOpen = null;

		const focusableSelectors = [
			'a[href]',
			'button:not([disabled])',
			'textarea:not([disabled])',
			'input:not([disabled])',
			'select:not([disabled])',
			'[tabindex]:not([tabindex="-1"])'
		].join( ', ' );

		const getFocusableElements = () => {
			const filter = getFilter();
			return filter ? Array.from( filter.querySelectorAll( focusableSelectors ) ) : [];
		};

		const getFirstFocusableElement = () => {
			const elements = getFocusableElements();
			return elements[ 0 ] || null;
		};

		const openPopup = () => {
			const filter = getFilter();
			if ( ! filter ) {
				return;
			}

			activeElementBeforeOpen = document.activeElement;
			filter.classList.add( '-isPopup', '-isOpen' );
			if ( overlay ) {
				overlay.classList.add( '-isOpen' );
			}
			openButton.setAttribute( 'aria-expanded', 'true' );
			filter.setAttribute( 'role', 'dialog' );
			filter.setAttribute( 'aria-modal', 'true' );
			filter.id = 'archive-filter-popup';
			document.body.style.overflow = 'hidden';

			getCloseButtons().forEach( button => {
				button.removeAttribute( 'tabindex' );
			} );

			setTimeout( () => {
				const firstFocusable = getFirstFocusableElement();
				if ( firstFocusable ) {
					firstFocusable.focus();
				}
			}, 10 );
		};

		const closePopup = () => {
			const filter = getFilter();
			// Alleen iets doen als de popup echt openstaat. Op desktop is de sidebar
			// geen popup en zijn de sluitknoppen display:none; deze handler mag daar
			// nooit de body-scroll of de focus aanraken.
			if ( ! filter || ! filter.classList.contains( '-isOpen' ) ) {
				return;
			}

			filter.classList.remove( '-isOpen' );
			if ( overlay ) {
				overlay.classList.remove( '-isOpen' );
			}
			openButton.setAttribute( 'aria-expanded', 'false' );
			filter.removeAttribute( 'role' );
			filter.removeAttribute( 'aria-modal' );
			document.body.style.overflow = '';

			getCloseButtons().forEach( button => {
				button.setAttribute( 'tabindex', '-1' );
			} );

			if ( activeElementBeforeOpen ) {
				activeElementBeforeOpen.focus();
				activeElementBeforeOpen = null;
			}
		};

		const handleKeyDown = ( e ) => {
			const filter = getFilter();
			if ( ! filter || ! filter.classList.contains( '-isOpen' ) ) {
				return;
			}

			if ( 'Escape' === e.key ) {
				e.preventDefault();
				closePopup();
				return;
			}

			if ( 'Tab' === e.key ) {
				const elements = getFocusableElements();
				if ( 0 === elements.length ) {
					e.preventDefault();
					return;
				}

				const firstElement = elements[ 0 ];
				const lastElement = elements[ elements.length - 1 ];

				if ( e.shiftKey ) {
					if ( document.activeElement === firstElement ) {
						e.preventDefault();
						lastElement.focus();
					}
				} else {
					if ( document.activeElement === lastElement ) {
						e.preventDefault();
						firstElement.focus();
					}
				}
			}
		};

		openButton.addEventListener( 'click', openPopup );

		// Klikdelegatie in plaats van listeners per knop: het kruisje en
		// 'Filters toepassen' zitten in de sidebar-inhoud die live wordt vervangen,
		// dus een listener op de knop zelf overleeft de eerste filterwijziging niet.
		// De overlay valt onder dezelfde selector en loopt hier dus in mee.
		document.addEventListener( 'click', ( e ) => {
			if ( e.target.closest && e.target.closest( '.js-close-filters' ) ) {
				closePopup();
			}
		} );

		document.addEventListener( 'keydown', handleKeyDown );
	};

	// Wait for DOM to be ready
	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		// DOM is already ready
		init();
	}

} )();